module.exports = __webpack_public_path__ + "static/favicon-37161ce361b773e21b8ef44d82accbfa.png";